var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 57,
    viewBox: "0 0 64 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "triangle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1114 7.10726L59.7411 39.3048C63.6006 45.6354 59.0441 53.75 51.6297 53.75H12.3703C4.95594 53.75 0.399355 45.6354 4.2589 39.3048L23.8886 7.10726C27.5911 1.03424 36.4089 1.03424 40.1114 7.10726Z",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTriangle);
export default __webpack_public_path__ + "static/media/filter-triangle.dacd132473a44c02d6f260fb78157b74.svg";
export { ForwardRef as ReactComponent };